import { FundChartCreatorModule } from './app.module';
import { bootstrapAppModule } from 'Angular/utils/app-bootstrapping';
bootstrapAppModule(FundChartCreatorModule);
